import { IconStores } from 'assets'
import { WarningMessage } from 'components'
import {
  EntityCount,
  ImagePortrait,
  PageHeader,
  RatingStars,
  TableBodyContainer,
  TableBodyLine,
  TableContainer,
  TableHeader,
  Text1
} from '@touche-lts/panel-ui/dist'
import { TableCellWithAdditionalCount, TableTagsCell } from 'components/shared'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Brand } from 'models'
import React, { useEffect, useState } from 'react'
import { BRAND_STORE, ROUTING_STORE } from 'store'
import {
  getMainImageSrcForObj,
  getSortingResult,
  SortDirection
} from 'utilities'
import styles from './BrandsPage.module.scss'
import { BrandsPageProps } from './BrandsPage.types'
import tableBodyContainerStyle from '../../../components/shared/TableBodyContainer/TableBodyContainer.module.scss'

const BrandsPageComponent = (props: BrandsPageProps) => {
  const {
    [BRAND_STORE]: { getBrands, brandsList },
    [ROUTING_STORE]: { push }
  } = props

  useEffect(() => getBrands(true, true), [getBrands])

  const [nameSortDirection, setNameSortDirection] = useState(SortDirection.ASC)

  const sortByName = (a: Brand, b: Brand) => {
    const nameA = a.name
    const nameB = b.name
    return getSortingResult(nameA, nameB, nameSortDirection)
  }

  const [nameSearch, setNameSearch] = useState('')
  const [projectsSearch, setProjectsSearch] = useState('')
  const [tagsSearch, setTagsSearch] = useState('')
  const [ratingsSelect, setRatingsSelect] = useState('')

  const handleSortStore = () => {
    if (nameSortDirection === SortDirection.DESC) {
      setNameSortDirection(SortDirection.ASC)
    } else {
      setNameSortDirection(SortDirection.DESC)
    }
  }

  const applyFilters = (brand: Brand) => {
    const nameFilter = nameSearch
      ? brand.name.toLowerCase().includes(nameSearch.trim().toLowerCase())
      : true
    const projectsFilter = projectsSearch
      ? (brand.projects || []).some(p =>
        p.name.toLowerCase().includes(projectsSearch.trim().toLowerCase())
      )
      : true
    const tagsFilter = tagsSearch
      ? (brand.tags || '')
        .toLowerCase()
        .includes(tagsSearch.trim().toLowerCase())
      : true
    const ratingsFilter = ratingsSelect
      ? ratingsSelect === 'less-than-three'
        ? (brand.rating || 0) < 3
        : (brand.rating || 0) >= 3
      : true

    return nameFilter && projectsFilter && tagsFilter && ratingsFilter
  }

  return (
    <div className={styles.pageContainer} style={{ overflow: 'hidden' }}>
      <PageHeader
        navSegments={[
          {
            label: 'Stores',
            icon: IconStores as any
          }
        ]}
      />
      <TableContainer style={ { overflow: 'auto' } } className={styles.thinScroll}>

        <TableHeader
          tableColumns={[
            {
              label: 'stores',
              sortDirection: nameSortDirection,
              setSortDirection: handleSortStore,
              inputProps: {
                placeholder: 'Search...',
                value: nameSearch,
                onChange: setNameSearch
              },
              widthPx: 300
            },
            {
              label: 'ratings',
              selectProps: {
                options: [
                  {
                    label: '< 3',
                    value: 'less-than-three'
                  },
                  {
                    label: '> 3',
                    value: 'greater-than-three'
                  }
                ],
                value: ratingsSelect,
                onChange: setRatingsSelect
              },
              widthPx: 300
            },
            {
              label: 'projects',
              inputProps: {
                placeholder: 'Search...',
                value: projectsSearch,
                onChange: setProjectsSearch
              },
              widthPx: 300
            },
            {
              label: 'products',
              widthPx: 300
            },
            {
              label: 'active agreements',
              widthPx: 300
            },
            {
              label: 'tags',
              inputProps: {
                placeholder: 'Search...',
                value: tagsSearch,
                onChange: setTagsSearch
              },
              widthPx: 310
            }
          ]}
        />
        <TableBodyContainer className={tableBodyContainerStyle.tableBodyContainer}>
          {brandsList
            .filter(applyFilters)
            .sort(sortByName)
            .map(brand => {
              return (
                <TableBodyLine
                  key={brand.id}
                  cells={[
                    {
                      // widthPercentage: 16.6,
                      children: (
                        <>
                          <ImagePortrait
                            src={getMainImageSrcForObj(brand)}
                            width={23.8}
                          />
                          <Text1 bold style={{ marginLeft: 12 }}>
                            {brand.name}
                          </Text1>
                          <WarningMessage object={brand} objectType='brand' />
                        </>
                      ),
                      onClick: () => push(`/brands/edit/${brand.id}`),
                      widthPx: 300
                    },
                    {
                      // widthPercentage: 16.6,
                      children: <RatingStars rating={brand.rating} />,
                      widthPx: 300
                    },
                    {
                      // widthPercentage: 16.6,
                      children: (
                        <TableCellWithAdditionalCount
                          text={brand.projectsInfoCol.projectName}
                          additionalCount={
                            brand.projectsInfoCol.additionalCount
                          }
                        />
                      ),
                      widthPx: 300
                    },
                    {
                      // widthPercentage: 16.6,
                      children: (
                        <EntityCount
                          entity='product'
                          count={brand.numberProducts}
                        />
                      ),
                      widthPx: 300
                    },
                    {
                      // widthPercentage: 16.6,
                      children: (
                        <EntityCount
                          entity='agreement'
                          count={brand.activeAgreementsCnt}
                        />
                      ),
                      widthPx: 300
                    },
                    {
                      // widthPercentage: 16.6,
                      children: <TableTagsCell tags={brand.tags} />,
                      style: { flexWrap: 'wrap' },
                      widthPx: 304
                    }
                  ]}
                />
              )
            })}
        </TableBodyContainer>
      </TableContainer>
    </div>
  )
}

const BrandsPage = inject(
  BRAND_STORE,
  ROUTING_STORE
)(observer(BrandsPageComponent))
export { BrandsPage }
